module.exports = __webpack_public_path__ + "static/media/slider-gradient.b88b8405.png";